import React from "react";

export const UnacceptIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6.14258" y="3.85693" width="12.7287" height="1.81838" rx="0.909191" transform="rotate(45 6.14258 3.85693)" fill="#FF5D5D"/>
    <rect x="15.1426" y="5.14355" width="12.7287" height="1.81838" rx="0.909191" transform="rotate(135 15.1426 5.14355)" fill="#FF5D5D"/>
  </svg>
)
